
  
  /*function updateContent(variantId) {
        var container = $('#store_availability')[0];
        var variantSectionUrl =
        container.dataset.baseUrl +
        'variants/' +
        variantId + 
        '/?section_id=store-availability';
        $.ajax({
          type: "get",
          url: variantSectionUrl,
          success: function(data) {
            if ($(data).find('.store-availability-container').html() != '') {
              $('#store_availability').html(data);
                var title = $('#store_availability').data('product-title');
              $('[data-store-availability-modal-product-title]').text(title);
            }
          }
        });
    };*/

  var buttonSlt = '[data-minus-qtt], [data-plus-qtt]',
      buttonElm = $(buttonSlt);

  $(document).on('click', buttonSlt, function(e) {
      e.preventDefault();
      e.stopPropagation();

      var self = $(this),
          input = $('.quantity input[name="quantity"]').not('.item-quantity').not('.custom-input-quantity'),
          oldVal = parseFloat(input.val()),
          newVal = 1;

      switch (true) {
          case (self.hasClass('plus-qty')): {
              newVal = oldVal + 1;
              break;
          }
          case (self.hasClass('minus-qty') && oldVal > 1): {
              newVal = oldVal - 1;
              break;
          }
          case (self.hasClass('plus')): {
              newVal = oldVal + 0.5;
              break;
          }
          case (self.hasClass('minus') && oldVal > 1): {
              newVal = oldVal - 0.5;
              break;
          }
      }

      input.val(newVal);
      updatePricing();
  });
    
    $('[data-qtt-id]').on('change', updatePricing);



    function updatePricing() {
      var quantity = parseFloat($('[data-qtt-id]').val());
      console.log("quantity =" +quantity);
      var p = $('.product-block-list__wrapper #product_regular_price').val();
      console.log("p =" +p);
      var totalPrice1 = p * quantity;
      console.log("totalPrice1 =" +totalPrice1);
      var g = Shopify.formatMoney(totalPrice1, window.money_format);
      //var g = 200
      console.log("g =" +g);
      $('.product-block-list__wrapper .total-price span').html(g);
 };



  
    var inven_array = {
      
      "42637917880469":"92",
      
    };
    var inven_num = '';

    var selectCallback = function(variant, selector) {
        var addToCartBtn = $('#product-add-to-cart'),
            productPrice = $('.product .price'),
            comparePrice = $('.product .compare-price'),
            productInventory = $('.product-inventory'),
            productSku = $('.product .sku-product'),
            labelSave = $('.product-photos .sale-label'),
            max_stock = $('[data-stock-hot]').data('value'),
            qtyinput = $('[name="quantity"]');

        if(variant) {
        // addToCartbtn
            if (variant.available) {
                if (variant.inventory_management!=null) {
                  for( variant_id in inven_array){
                    if(variant.id == variant_id ){
                      inven_num = inven_array[variant_id];
                      var inventoryQuantity = parseInt(inven_num);
                      qtyinput.attr('max',inventoryQuantity);
                    }
                  }
                  // Hot stock
                  if(inventoryQuantity > 0 && inventoryQuantity <= max_stock){
                      var text_stock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
                      $('[data-stock-hot]').text(text_stock).show();
                      productInventory.find('span').text(inventoryQuantity + ' ' + window.inventory_text.in_stock);
                      
                  }else if (inventoryQuantity > 0) {
                      productInventory.find('span').text(inventoryQuantity + ' ' + window.inventory_text.in_stock);
                      $('[data-stock-hot]').hide();
                  } else{
                    productInventory.find('span').text(window.inventory_text.out_of_stock);
                    $('[data-stock-hot]').hide();
                  }
                  // Button Text
                  if(inventoryQuantity > 0){
                    // We have a valid product variant, so enable the submit button
                    addToCartBtn.removeClass('disabled').removeAttr('disabled').val(window.inventory_text.add_to_cart);
                    $('.groups-btn').removeClass('remove');
                  }else{
                    addToCartBtn.removeClass('disabled').removeAttr('disabled').val(window.inventory_text.pre_order);
                    $('.groups-btn').addClass('remove');
                  }
                } else {
                  
                  addToCartBtn.removeClass('disabled').removeAttr('disabled').val(window.inventory_text.add_to_cart);
                }
                $('[data-form-notify]').slideUp();
                $('[data-soldOut-product]').show();
            }
            else {
                $('[data-soldOut-product]').hide();
                addToCartBtn.val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
                $('[data-stock-hot]').hide();
                $('[data-form-notify]').slideDown();
                var url = window.location.href.split('?variant')[0];
                $('[data-value-email]').val(url + '?variant=' + variant.id);
                productInventory.find('span').text(window.inventory_text.out_of_stock);
                $('[data-stock-hot]').hide();
            };

        // Prices
            $('.product-template .swatch').each(function(){
              $(this).find('[data-option-select]').text($(this).find('input:checked').val());
            })
            $('.product #product_regular_price').val(variant.price);
            productPrice.html(Shopify.formatMoney(variant.price, "₹ "));

            if(variant.compare_at_price > variant.price) {
                productPrice.addClass("on-sale");
                comparePrice
                    .html(Shopify.formatMoney(variant.compare_at_price, "₹ "))
                    .show();
               
            }
            else {
                comparePrice.hide();
                productPrice.removeClass("on-sale");
                
            };

            
            updatePricing();
            
           var form = $('#' + selector.domIdPrefix).closest('form');

            for (var i=0,length=variant.options.length; i<length; i++) {
                var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');

                if (radioButton.size()) {
                    radioButton.get(0).checked = true;
                }
            };

            $('.product-template .swatch').each(function(){
              $(this).find('[data-option-select]').text($(this).find('input:checked').val());
            })
        }
        else {
            addToCartBtn.val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
        };

        
        if (variant) {
            productSku.find('span').text(variant.sku);
        }
        else {
            productSku.find('span').empty();
        }
        

        updateContent(variant.id);

        
          /*begin variant image*/
          $(document).ready(function(){
              if (variant && variant.featured_image) {
                  var originalImage = $("img[id|='product-featured-image']");
                  var newImage = variant.featured_image;
                  var element = originalImage[0];

                  Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
                      jQuery('.slider-nav img').each(function() {
                          var grandSize = $(this).attr('src').split('?')[0].replace('_compact','');
                        

                        newImageSizedSrc = newImageSizedSrc.split('?')[0].replace('https:','').replace('http:','');
                          if(grandSize === newImageSizedSrc) {
                              var item = $(this).closest('.item');

                              item.trigger('click');
                              return false;
                          }
                      });
                  });
              };
          });
        

    };

    $(function($) {
        if($('#product-selectors').length > 0){
          new Shopify.OptionSelectors('product-selectors', {
              product: {"id":7621852168341,"title":"Cotton Printed Fabric","handle":"cotton-printed-fabric-5","description":"This cotton fabric is Table printed. It is ideal for Comfort wear. It can be styled as a short Kurta, Pants and Skirt  to pair with your shirts for your everyday. Cotton fabric is a comfortable, soft, breathable fabric with little sheen. \u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eWidth-44\"\u003cbr data-mce-fragment=\"1\"\u003eProduct Care- First time Hand Wash\/ Dry Clean only\u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eDISCLAIMER: There may be slight colour variations due to different screen resolution and Photographic Lighting Sources used.","published_at":"2022-08-20T19:45:01+05:30","created_at":"2022-08-12T15:13:39+05:30","vendor":"FABRIC HUB SURAT","type":"fabrics","tags":["cotton","diwali230","diwali249","sale","stripes","Table Print","yellow"],"price":5000,"price_min":5000,"price_max":5000,"available":true,"price_varies":false,"compare_at_price":25000,"compare_at_price_min":25000,"compare_at_price_max":25000,"compare_at_price_varies":false,"variants":[{"id":42637917880469,"title":"Default Title","option1":"Default Title","option2":null,"option3":null,"sku":"FHFCOTPSTYE","requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"Cotton Printed Fabric","public_title":null,"options":["Default Title"],"price":5000,"weight":30,"compare_at_price":25000,"inventory_management":"shopify","barcode":""}],"images":["\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967"],"featured_image":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","options":["Title"],"media":[{"alt":null,"id":27427785375893,"position":1,"preview_image":{"aspect_ratio":0.667,"height":2500,"width":1668,"src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949"},"aspect_ratio":0.667,"height":2500,"media_type":"image","src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","width":1668},{"alt":null,"id":27427787309205,"position":2,"preview_image":{"aspect_ratio":0.667,"height":1900,"width":1267,"src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967"},"aspect_ratio":0.667,"height":1900,"media_type":"image","src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967","width":1267}],"content":"This cotton fabric is Table printed. It is ideal for Comfort wear. It can be styled as a short Kurta, Pants and Skirt  to pair with your shirts for your everyday. Cotton fabric is a comfortable, soft, breathable fabric with little sheen. \u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eWidth-44\"\u003cbr data-mce-fragment=\"1\"\u003eProduct Care- First time Hand Wash\/ Dry Clean only\u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eDISCLAIMER: There may be slight colour variations due to different screen resolution and Photographic Lighting Sources used."},
              onVariantSelected: selectCallback,
              enableHistoryState: true
          });
        }
        Shopify.linkOptionSelectors({"id":7621852168341,"title":"Cotton Printed Fabric","handle":"cotton-printed-fabric-5","description":"This cotton fabric is Table printed. It is ideal for Comfort wear. It can be styled as a short Kurta, Pants and Skirt  to pair with your shirts for your everyday. Cotton fabric is a comfortable, soft, breathable fabric with little sheen. \u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eWidth-44\"\u003cbr data-mce-fragment=\"1\"\u003eProduct Care- First time Hand Wash\/ Dry Clean only\u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eDISCLAIMER: There may be slight colour variations due to different screen resolution and Photographic Lighting Sources used.","published_at":"2022-08-20T19:45:01+05:30","created_at":"2022-08-12T15:13:39+05:30","vendor":"FABRIC HUB SURAT","type":"fabrics","tags":["cotton","diwali230","diwali249","sale","stripes","Table Print","yellow"],"price":5000,"price_min":5000,"price_max":5000,"available":true,"price_varies":false,"compare_at_price":25000,"compare_at_price_min":25000,"compare_at_price_max":25000,"compare_at_price_varies":false,"variants":[{"id":42637917880469,"title":"Default Title","option1":"Default Title","option2":null,"option3":null,"sku":"FHFCOTPSTYE","requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"Cotton Printed Fabric","public_title":null,"options":["Default Title"],"price":5000,"weight":30,"compare_at_price":25000,"inventory_management":"shopify","barcode":""}],"images":["\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967"],"featured_image":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","options":["Title"],"media":[{"alt":null,"id":27427785375893,"position":1,"preview_image":{"aspect_ratio":0.667,"height":2500,"width":1668,"src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949"},"aspect_ratio":0.667,"height":2500,"media_type":"image","src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-127.jpg?v=1660299949","width":1668},{"alt":null,"id":27427787309205,"position":2,"preview_image":{"aspect_ratio":0.667,"height":1900,"width":1267,"src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967"},"aspect_ratio":0.667,"height":1900,"media_type":"image","src":"\/\/fabrichubsurat.com\/cdn\/shop\/products\/Images-125.jpg?v=1660299967","width":1267}],"content":"This cotton fabric is Table printed. It is ideal for Comfort wear. It can be styled as a short Kurta, Pants and Skirt  to pair with your shirts for your everyday. Cotton fabric is a comfortable, soft, breathable fabric with little sheen. \u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eWidth-44\"\u003cbr data-mce-fragment=\"1\"\u003eProduct Care- First time Hand Wash\/ Dry Clean only\u003cbr data-mce-fragment=\"1\"\u003e\u003cbr data-mce-fragment=\"1\"\u003eDISCLAIMER: There may be slight colour variations due to different screen resolution and Photographic Lighting Sources used."}, '.product');
        $('.product-shop .selector-wrapper label').append('<em>*</em>');
          $('.selector-wrapper').hide();
        // Add Data Countdown Sticky
          var countdown_different = $('.product-shop .countdown-item').data('countdown-value');
          $('[data-sticky-add-to-cart] .countdown-item').attr('data-countdown-value',countdown_different);
    });


